<template>
  <div class="device-detail-maintain">
    <div class="table-bd">
      <div class="table-list">
        <!--
         保养日期
          finishTime
          单号
          workOrderCode
          售后公司
          afterServiceName
          保养人员
          technicianName
          保养人所属公司
          technicianOrgName
        -->
        <ul class="table-head">
          <li class="ub-f1">{{ $t('device_detail_maintain.wan_cheng_ri_qi') }}</li>
          <li class="ub-f1">{{ $t('device_detail_maintain.gong_dan_hao') }}</li>
          <li class="ub-f1">{{ $t('device_detail_maintain.shou_hou_gong_si') }}</li>
          <li class="ub-f1">{{ $t('device_detail_maintain.shou_hou_ren_yuan') }}</li>
          <!-- <li class="ub-f1"></li> -->
        </ul>
        <ul class="table-body">
          <template v-if="tableList.length > 0">
            <li class="line" v-for="item in tableList" :key="item.workOrderId" @click="onRowClick(item)">
              <ul class="content">
                <li class="ub-f1">
                  {{ $momentLocal(item.finishTime,'YYYY-MM-DD') }}
                </li>
                <li class="ub-f1">
                  {{ item.workOrderCode || '-' }}
                </li>
                <li class="ub-f1">
                  {{ item.afterServiceName || '-' }}
                </li>
                <li class="ub-f1">
                  {{ item.technicianName || '-' }}
                </li>
                <!-- <li class="ub-f1">
                  {{ item.technicianOrgName || '-' }}
                </li> -->
                <!-- <li class="ub-f1" style="display: flex; justify-content: flex-end">
                  <i class="link icon icon-you"></i>
                </li> -->
              </ul>
            </li>
          </template>

          <li class="no-data" v-else>{{ $t('Common.com_no_data') }}</li>
        </ul>
      </div>
      <div class="table-footer">
        <custom-pagination :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-pagination>
      </div>
    </div>

  </div>
</template>

<script>
// import moment from 'moment';
import apis from '@/utils/apis';

export default {
  name: 'openCard',
  props: {
    deviceInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {},
  data() {
    return {
      formSearch: {
        pageSize: 50,
        pageNum: 1,
        search: '',
        orderBy: '',
        orderType: '',
        deviceId: '',
        workOrderType: '20',
      },
      tableList: [],
      totalRows: null,
      // {
      //   finishTime: '2021-04-26 16:30',
      //   technicianName: '小威',
      //   technicianOrgName: '东城清洁设备有限公司',
      //   workOrderCode: 'BY20210426000003',
      //   workOrderDesc: '',
      //   workOrderId: '584089391022821376',
      //   workOrderType: 20,
      // }
    };
  },
  watch: {},

  mounted() {
    this.getTableList();
  },
  methods: {
    onRowClick(e) {
      const query = {
        caseOrderId: e.caseOrderId,
        workOrderId: e.workOrderId,
        pageType: 'maintain',
        isWorkOrder: true,
        prePageIsDeviceDetail: true
      };
      this.jump('/service/order/detail/detail', query);
    },
    getTableList() {
      this.formSearch.deviceId = this.deviceInfo.deviceId;
      this.$getJSON(apis.DeviceResumeWorkOrderPage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';
.device-detail-maintain {
  .table-bd {
    background: #ffffff;
    border-radius: 16px;
    padding: 24px 24px 0;
    .title {
      height: 40px;
      font-size: 18px;
      font-weight: bold;
      color: #1a1a1a;
      line-height: 40px;
      display: flex;
      justify-content: space-between;
    }
    .table-list {
      margin-top: 24px;

      .table-head {
        height: 40px;
        display: flex;
        border-bottom: 1px solid #f0f0f0;
        padding: 0 16px;
        li {
          line-height: 40px;
          font-size: 14px;
          font-weight: bold;
          color: $--color-text-secondary;
        }
      }
      .table-body {
        height: 250px;
        overflow-y: auto;
        .line {
          height: 48px;
          padding: 0 16px;
          cursor: pointer;
          &:nth-of-type(even) {
            background-color: #f8f9fa;
          }
          .content {
            height: 48px;
            line-height: 48px;
            display: flex;
            li {
              line-height: 48px;
              font-size: 14px;
              color: $--color-text-regular;
              .card-info {
                display: flex;
                align-items: center;
                img {
                  width: 30px;
                  height: 30px;
                }
                span {
                  margin-left: 24px;
                }
              }
            }
            .edit {
              color: $--color-primary;
              font-size: 12px;
            }
          }
        }
        .no-data {
          margin-top: 24px;
          height: 130px;
          text-align: center;
          line-height: 130px;
          font-size: 16px;
          color: #818181;
          background: #ffffff;
          border-radius: 16px;
        }
      }
    }
  }
}
</style>
